import { ErrorView } from '@components/Error'
import { siteConfig } from '@config/site-config'
import { OdinProvider } from '@context/OdinProvider'
import { type LinksFunction, type MetaFunction } from '@remix-run/cloudflare'

import {
  isRouteErrorResponse,
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useRouteError,
} from '@remix-run/react'
import { ThemeProvider } from 'next-themes'
import { Button } from 'react-daisyui'

import tailwindCSS from './css/app.css?url'

export const links: LinksFunction = () => [
  {
    media: 'screen and (min-width: 520px)',
    rel: 'preconnect',
    href: 'https://fonts.googleapis.com',
    crossOrigin: 'anonymous',
  },
  {
    media: 'screen and (min-width: 520px)',
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
    crossOrigin: 'anonymous',
  },
  {
    rel: 'stylesheet',
    href: 'https://fonts.googleapis.com/css2?family=Inter:wght@300;900&display=swap',
    media: 'screen and (min-width: 520px)',
  },
  { rel: 'stylesheet', href: tailwindCSS, crossOrigin: 'anonymous' },
  {
    rel: 'canonical',
    href: `https://${siteConfig.appName.toLowerCase()}.dtlr.io`,
  },
]

export const meta: MetaFunction = () => {
  return [{ title: siteConfig.appName }]
}

export default function App() {
  // noinspection HtmlRequiredTitleElement
  return (
    <html lang="en" suppressHydrationWarning={true}>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" type="image/x-icon" />
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="57x57" href="/apple-touch-icon-57x57.png" />
        <link rel="apple-touch-icon" sizes="72x72" href="/apple-touch-icon-72x72.png" />
        <link rel="apple-touch-icon" sizes="76x76" href="/apple-touch-icon-76x76.png" />
        <link rel="apple-touch-icon" sizes="114x114" href="/apple-touch-icon-114x114.png" />
        <link rel="apple-touch-icon" sizes="120x120" href="/apple-touch-icon-120x120.png" />
        <link rel="apple-touch-icon" sizes="144x144" href="/apple-touch-icon-144x144.png" />
        <link rel="apple-touch-icon" sizes="152x152" href="/apple-touch-icon-152x152.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon-180x180.png" />
        <Meta />
        <Links />
      </head>
      <body>
        <ThemeProvider
          enableColorScheme={true}
          defaultTheme={siteConfig.defaultTheme}
          themes={siteConfig.themes}
          disableTransitionOnChange={true}
          storageKey={'odin-theme'}
        >
          <OdinProvider>
            <Outlet />
            <ScrollRestoration />
            <Scripts />
          </OdinProvider>
        </ThemeProvider>
      </body>
    </html>
  )
}
export function ErrorBoundary() {
  const error = useRouteError()
  let status_code: number = 0
  let status_msg: string = ''
  let msg: string = ''

  if (isRouteErrorResponse(error)) {
    status_code = error.status
    status_msg = error.statusText
    msg = error.data
  }

  return (
    <html lang="en-US" suppressHydrationWarning={true} className="h-full">
      <head>
        <title>Oh No!</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body className="h-full">
        <ThemeProvider
          enableColorScheme={true}
          defaultTheme={siteConfig.defaultTheme}
          themes={siteConfig.themes}
          disableTransitionOnChange={true}
          storageKey={'odin-theme'}
        >
          <ErrorView
            title={status_msg}
            heading={status_code}
            message={msg}
            cta={<Button color={'ghost'}>Contact support</Button>}
          />
          <Scripts />
        </ThemeProvider>
      </body>
    </html>
  )
}
